export const tokenAction = (state, payload) => {
  return {
    ...state,
    token: payload
  };
};
